import React from "react";
import { AnimatePresence, motion } from "framer-motion";

const AnimatedComponent = ({ children }) => {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={"empty"}
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -50, opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default AnimatedComponent;
